export { default } from "./AdminBetaApp";
